// @flow

import React, { Component } from 'react';
import Alert from 'react-s-alert';
import localforage from 'localforage';
import mapSeries from 'async/mapSeries';
import _ from 'lodash';

import {mav_rows, takeFilename, takeExtension, takeDir, noop, ms_regex} from './utils.js';
import {fetch_shp, get_mav_detail} from './fetch_things.js';
import {is_empty_mav} from './types.js';

import DialogMav from './DialogMav.jsx';
import PostMav from './PostMav.jsx';
import TableMav from './TableMav.jsx';
import Map from './Map.jsx';
import Dbf from './Dbf.jsx';
import XDialog from './XDialog.jsx';
import Escala from './Escala.jsx';
import FourMaps from './FourMaps.jsx';
import App from './App.jsx';

import Shp from './Shp.js';
import Img from './Img.js';
import {SIDEBAR_WIDTH} from './consts.js';

import type {T_Next, T_MavDetail, T_ReporteEscalasLyr, T_IconPair} from './types.js';
import type {T_ShpFile} from './Shp.js';
import type {T_ImgFile} from './Img.js';
import type {T_Dbf} from './Dbf.jsx';
import type {T_PostMavProps} from './PostMav.jsx';

import './css/MapUI.css';


type T_MapUIProps = {
  four_maps          : boolean,
  symmetric_four_maps: boolean,
  fix_zoom           : boolean,
  show_tree          : boolean,
  hide_extras        : boolean,
  width              : number,
  height             : number,
  window_drag        : boolean,
  show_dialog_user   : boolean,
  show_dialog_tools  : boolean,
  num_decimals       : number,
  dev_mode           : boolean,
  use_color_brewer   : boolean,
  full_height        : boolean,
  closing_four_maps  : boolean,
  show_escalas_below : boolean,
  map_border         : boolean,
  app                : App
};


type T_MapUIState = {
  escala_for      : ?string,
  dbf             : ?T_Dbf,
  dbf_hl          : ?string,
  show_mav        : boolean,
  mav_detail      : ?T_MavDetail,
  zombie_mav      : ?T_PostMavProps,
  cultis          : Array<string>,
  all_shp_is_culti: boolean,
  restore_shp     : string,
  restore_img     : string,
  dbf_width       : number
};



export default class MapUI extends Component<T_MapUIProps, T_MapUIState> {
  map: Map;
  
  Lyr_List: { [string]: T_ReporteEscalasLyr };              // mapa asociativo de carpetas a T_ReporteEscalasLyr
  Lim_List: { [string]: { [string]: [number, number] } };   // límites [min, max] de todos los png_files de un directorio.
  
  escala   : ?Escala;
  table_mav: ?TableMav;
  
  show_shp    : (shape: T_ShpFile, next: T_Next, map?: Map) => void;
  close_shp   : (path: string, next: T_Next) => void;
  show_img    : (img: T_ImgFile, next: T_Next, map?: Map) => void;
  close_img   : (path: string, next: T_Next) => void;
  activate_map: (i: number) => void;
  toggle_mav  : (next?: T_Next) => void;
  
  
  
  constructor(props: T_MapUIProps) {
    super(props);
    
    this.state = {
      escala_for      : null,
      dbf             : null,
      dbf_hl          : null,
      show_mav        : false,
      mav_detail      : null,
      zombie_mav      : null,
      four_maps       : false,   // está dividida la pantalla en cuatro?
      cultis          : [],
      all_shp_is_culti: true,
      restore_shp     : '',
      restore_img     : '',
      dbf_width       : 100
    };
    
    this.Lyr_List = {};
    this.Lim_List = {};
    
    this.escala = null;
    
    props.app.map_ui = this;
    
    this.show_shp     = this.show_shp.bind(this);
    this.close_shp    = this.close_shp.bind(this);
    this.show_img     = this.show_img.bind(this);
    this.close_img    = this.close_img.bind(this);
    this.activate_map = this.activate_map.bind(this);
    this.toggle_mav   = this.toggle_mav.bind(this);
  }
  
  
  
  componentDidUpdate(prevProps: T_MapUIProps, prevState: T_MapUIState) {
    if (this.props.four_maps !== prevProps.four_maps) {
      this.toggle_four_maps();
    }
    else if (this.props.four_maps && this.state.cultis.length !== prevState.cultis.length) {
      this.change_culti(_.last(this.state.cultis), noop, true, true);
    }
    
    if (this.props.four_maps && this.state.restore_img !== prevState.restore_img) {
      const item_png = this.props.app.get_item_png(this.state.restore_img);
      
      if (item_png != null && ! item_png.state.Loaded) {
        item_png.open();
      }
    }
    
    const bar_state = {};
    
    if (this.state.cultis.length !== prevState.cultis.length) {
      bar_state.cultis = this.state.cultis;
    }
    
    if (this.state.escala_for !== prevState.escala_for) {
      bar_state.escala_for = this.state.escala_for;
    }
    
    if (_.keys(bar_state).length > 0 && this.props.app.bar != null) {
      this.props.app.bar.setState(bar_state);
    }
    
    if (prevProps.height !== this.props.height) {
      this.fix_resize();
    }
  }
  
  
  
  fix_resize(): void {
    if (this.props.four_maps && this.props.app.four_maps) {
      for (let num = 0; num < 4; num += 1) {
        if (this.props.app.four_maps.map_refs[num] != null) {
          this.props.app.four_maps.map_refs[num].fix_resize();
        }
      }
    }
    else {
      this.map.fix_resize();
    }
    
    if (this.props.app.medidas) {
      this.props.app.medidas.set_position();
    }
  }
  
  
  
  show_shp(shape: T_ShpFile, next: T_Next = noop, map: Map = this.map): void {
    if ((! shape) || map.is_loaded(shape.shpfile)) {
      return next(false);
    }
    
    const {app}    = this.props,
          shp: Shp = new Shp(app, map, shape);
    
    if (app.medidas) {
      app.medidas.clean_pixel_tool();
    }
    
    if (app.state.show_central_fert && app.central_fert != null && app.central_fert.state.path !== shape.shpfile) {
      app.setState({show_central_fert: false});
    }
    
    const new_state = {
      dbf       : null,
      dbf_hl    : null,
      cultis    : [],
      escala_for: this.state.escala_for,
      mav_detail: {rows: [], path: ''}
    };
    
    if (shp.is_culti || this.state.all_shp_is_culti) {
      new_state.cultis = _.cloneDeep(this.state.cultis);
      new_state.cultis.push(shp.obj.shpfile);
      new_state.escala_for = null;
    }
    
    if (shp.obj.is_mav && shp.obj.html_body) {
      new_state.mav_detail = {rows: mav_rows(shp.obj.html_body, shp.obj.dbfRecords), path: shp.obj.shpfile};
    }
    
    if (new_state.cultis.length === 0) {
      delete new_state.cultis;
    }
    
    if (new_state.escala_for === this.state.escala_for) {
      delete new_state.escala_for;
    }
    
    if (new_state.mav_detail.path === '') {
      delete new_state.mav_detail;
    }
    
    this.setState(new_state, () => {    // Toolbar va a reaccionar solo ante el cambio de cultis
      if (shp.obj.is_mav || shp.is_culti) {
        const dir = takeDir(shp.obj.shpfile),
              close_things = this.map.things_loaded().filter((path) => {
              return takeDir(path) === dir &&
                     (shp.is_culti ? takeFilename(path).indexOf('mav_') === 0 : ! takeFilename(path).match(ms_regex));
            });
        
        let opt = null;
        
        if (shp.obj.is_mav && _.some(close_things, path => takeFilename(path).indexOf('mav_') === 0)) {
          opt = {next_is_mav: true};
        }
        
        app.kill_these(close_things, () => {
          if (shp.obj.is_mav && is_empty_mav(this.state.mav_detail)) {
            get_mav_detail(app, shp.obj.shpfile, (mav_detail) => {
              if (mav_detail != null) {
                this.setState({mav_detail}, () => {
                  next(true);
                });
              }
              else {
                Alert.error('No pude obtener los detalles del mav');
              }
            });
          }
          else {
            next(true);
          }
        }, opt);
      }
      else {
        next(true);
      }
    });
  }
  
  
  
  close_shp(path: string, next: T_Next = noop): void {
    if (! this.map.is_loaded(path)) {
      return next(false);
    }
    
    const file     = takeFilename(path),
          is_culti = file.slice(0, 11) === 'cultivable_',
          {app} = this.props;
    
    if (app != null && app.state.show_central_fert && app.central_fert != null && app.central_fert.state.path === path) {
      app.setState({show_central_fert: false});
    }
    
    this.map.Shp_List[path].destroy(this.map);
    
    if (app.medidas) {
      if (this.map.Shp_List[path].sum_areas.sum > 0 && app.medidas.state.m_area === this.map.Shp_List[path].sum_areas.sum) {
        app.medidas.close();
      }
      else {
        app.medidas.clean_pixel_tool();
      }
    }
    
    delete this.map.Shp_List[path];
    
    const new_state = {};
    
    if (this.state.dbf && this.state.dbf.path === path) {
      new_state.dbf = null;
      new_state.dbf_hl = null;
    }
    
    if (this.state.mav_detail && this.state.mav_detail.path === path) {
      new_state.mav_detail = null;
    }
    
    if (is_culti || this.state.all_shp_is_culti) {
      new_state.cultis = this.state.cultis.filter(pc => pc !== path);
    }
    
    if (is_culti && this.state.escala_for != null && takeDir(this.state.escala_for) === takeDir(path)) {
      new_state.escala_for = null;
    }
    
    this.setState(new_state, () => next(true));
  }
  
  
  
  reload_shp(path: string, next: T_Next = noop): void {
    if (! this.map.is_loaded(path)) {
      return next(false);
    }
    
    this.close_shp(path, () => {
      fetch_shp(this.props.app, path, (response) => {
        if (typeof response !== 'string') {
          const shp = (response: T_ShpFile);
          
          this.show_shp(shp, next);
        }
      });
    });
  }
  
  
  
  show_img(img: T_ImgFile, next: T_Next = noop, map: Map = this.map): void {
    if ((! img) || map.is_loaded(img.img_filepath)) {
      return next(false);
    }
    
    Img.destroy_in(takeDir(img.img_filepath), map);
    
    new Img(this.props.app, map, img);
    
    if (this.props.app.medidas) {
      this.props.app.medidas.clean_pixel_tool();
    }
    
    this.setState({escala_for: img.img_filepath}, () => next(true));
  }
  
  
  
  close_img(path: string, next: T_Next = noop): void {
    if (! this.map.is_loaded(path)) {
      return next(false);
    }
    
    Img.destroy_in(takeDir(path), this.map);
    
    if (this.props.app.medidas) {
      this.props.app.medidas.clean_pixel_tool();
    }
    
    localforage.setItem(`${this.props.app.state.user.user_name}.last_png`, '').then(() => {
      this.setState({escala_for: null}, () => next(true));
    });
  }
  
  
  
  close_thing(path: string, next: T_Next = noop): void {
    const ext = takeExtension(path);
    
    if (ext === 'shp') {
      this.close_shp(path, next);
    }
    else if (ext === 'png') {
      this.close_img(path, next);
    }
  }
  
  
  
  close_all(next: T_Next = noop): void {
    mapSeries(this.map.things_loaded(), (path: string, callback) => {
      this.close_thing(path, () => callback(null, true));
    }, (err, rs) => {
      next(true);
    });
  }
  
  
  
  change_culti(val: string, next: T_Next, scroll_culti: boolean, must_chage_culti: boolean): void {
    if (! val) {
      return next(false);
    }
    
    const {app}    = this.props,
          dir      = takeDir(val),
          ch_culti = app.state.change_culti_on_close || must_chage_culti;
    
    const center = () => {
      if (ch_culti) {
        if (app.toolbar != null) {
          app.toolbar.center_culti(true, scroll_culti);
        }
        else {
          this.map.center_and_zoom_path(val);
        }
      }
    };
    
    const finale = () => {
      const escala_for = this.map.last_img_path(dir);
      
      this.setState({dbf: null, escala_for, zombie_mav: null}, () => next(true));
      
      this.map.touch(val);
      this.map.touch(escala_for);
      
      center();
      
      if (_.has(this.map.Shp_List, val)) {
        this.map.Shp_List[val].reset_hilight();
      }
    };
    
    const intermezzo = () => {
      if (app.toolbar != null) {
        app.toolbar.change_culti(val, finale);
      }
      else {
        finale();
      }
    };
    
    if (app.tree != null) {
      app.tree.hilight_shp(val, true, ch_culti, intermezzo);
    }
  }
  
  
  
  activate_map(num: number): void {
    if (this.props.four_maps && this.props.app.four_maps != null) {
      this.props.app.four_maps.activate_map(num);
    }
  }
  
  
  
  toggle_four_maps(): void {
    let restore_shp = this.map.last_culti_path();
    
    if ((! restore_shp) && this.state.cultis.length > 0) {
      restore_shp = this.state.cultis[0];
    }
    
    if (! restore_shp) {
      return Alert.error('Escoja un cultivable');
    }
    
    const dir         = takeDir(restore_shp),
          restore_img = this.map.last_img_path(dir),
          {app}       = this.props;
    
    app.is_ready['Map'] = false;
    app.is_ready['Medidas'] = false;
    
    this.setState({escala_for: null, dbf: null, mav_detail: null, dbf_hl: null});
    
    if (this.props.four_maps) {
      this.map.kill_all(() => {
        this.map.destroy();
        app.setState({fix_zoom: false}, () => {
          this.setState({cultis: [], restore_shp, restore_img});
        });
      });
    }
    else if (app.four_maps != null) {
      app.four_maps.destroy(() => {
        app.setState({closing_four_maps: false}, () => {
          app.refresh_items(() => {
            const end = () => {
              localforage.setItem(`${app.state.user.user_name}.last_png`, restore_img).then(() => {
                this.setState({cultis: [], restore_shp, restore_img}, () => {
                  this.fix_resize();
                });
              });
            };
            
            if (app.tree != null) {
              const item_dir = app.tree.get_sub_dir(dir);
              
              if (item_dir != null) {
                item_dir.refresh_all_sons(end);
              }
              else {
                end();
              }
            }
            else {
              end();
            }
          });
        });
      });
    }
  }
  
  
  
  change_icon(icon_pair: T_IconPair): void {
    Shp.icon_pair = icon_pair;
    
    if (this.props.four_maps && this.props.app.four_maps != null) {
      this.props.app.four_maps.reload_ms_icons();
    }
    else {
      this.map.reload_ms_icons();
    }
  }
  
  
  
  get_limits_of(png_path: string): ?[number, number] {
    const dir = takeDir(png_path),
          png = takeFilename(png_path);
    
    if (_.has(this.Lim_List, dir)) {
      if (_.has(this.Lim_List[dir], png)) {
        return this.Lim_List[dir][png];
      }
    }
    
    return null;
  }
  
  
  
  renew_escala(next: T_Next): void {
    const {app} = this.props;
    
    if (app.toolbar != null && ! this.state.escala_for) {
      const {culti}  = app.toolbar.state,
            dir      = takeDir(culti),
            img_path = this.map.last_img_path(dir);
      
      if (img_path) {
        this.setState({escala_for: img_path}, () => {
          next(true);
        });
      }
      else {
        next(false);
      }
    }
    else {
      next(false);
    }
  }
  
  
  
  get_html_escala_mt(): string {
    if (this.escala != null && this.escala.escala_mt != null) {
      return this.escala.escala_mt.get_inner_html();
    }
    else {
      return 'NO';
    }
  }
  
  
  
  get_html_table_mav(): string {
    if (this.table_mav != null) {
      return this.table_mav.get_inner_html();
    }
    else {
      return 'NO';
    }
  }
  
  
  
  toggle_mav(next?: T_Next): void {
    this.setState({show_mav: ! this.state.show_mav}, () => {
      this.props.app.setState({showing_mav: this.state.show_mav});
      
      if (next && _.isFunction(next)) {
        next(true);
      }
    });
  }
  
  
  
  render() {
    const offset_map      = SIDEBAR_WIDTH,
          dbf_file        = this.state.dbf != null ? takeFilename(this.state.dbf.path) : '',
          is_culti        = dbf_file.indexOf('cultivable_') === 0,
          is_mav          = dbf_file.indexOf('mav_') === 0,
          dbf_title       = this.state.dbf != null ? `Datos del ${is_culti ? 'potrero' : (is_mav ? 'polígono' : 'punto')}` : '',
          height          = this.props.height - (this.props.full_height ? 0 : 40),
          marginTop       = 0,
          style           = {marginLeft: offset_map, marginTop, height, width: this.props.width - offset_map, minWidth: 1024},
          font            = {font: this.props.app.favorite_font()},
          show_dialog_mav = this.state.show_mav && this.state.escala_for != null && this.props.app.toolbar != null,
          show_zombie_mav = this.state.zombie_mav != null,
          show_mav_detail = this.state.mav_detail != null && ! is_empty_mav(this.state.mav_detail);;
    
    // NOTE: EN PANTALLAS DE ANCHO MENOR A 1024, VA A HABER UNA BARRA DE SCROLL HORIZONTAL.
    
    return (
      <div className='map_container' style={style}>
        {(this.props.closing_four_maps || (this.props.four_maps && this.state.restore_shp)) ?
          <FourMaps
            shp={this.state.restore_shp}
            img={this.state.restore_img}
            show_tree={this.props.show_tree}
            width={this.props.width}
            height={this.props.height}
            show_dialog_user={this.props.show_dialog_user}
            show_dialog_tools={this.props.show_dialog_tools}
            dev_mode={false}
            full_height={this.props.full_height}
            symmetric={this.props.symmetric_four_maps}
            show_escalas_below={this.props.show_escalas_below}
            app={this.props.app}
          />
        :
          <Map
            num={0}
            name='Map'
            on_click={this.props.app.map_clicked}
            app={this.props.app}
            map_bts={true}
            escala_for=''
            map_border={this.props.map_border}
            full_size={true}
            four_maps={null}
          />
        }
        
        {(this.state.escala_for && _.has(this.map.Img_List, this.state.escala_for) &&
          (! this.props.hide_extras) && (! this.props.four_maps)) &&
          <Escala
            escala_for={this.state.escala_for}
            window_drag={this.props.window_drag}
            dev_mode={this.props.dev_mode}
            use_color_brewer={this.props.use_color_brewer}
            esc={this.map.Img_List[this.state.escala_for].obj.esc}
            lyr={
              this.props.dev_mode && this.map.Img_List[this.state.escala_for].obj.lyr != null ?
                this.map.Img_List[this.state.escala_for].obj.lyr
              :
                null
            }
            toggleable={true}
            no_close={false}
            app={this.props.app}
            ref={comp => this.escala = comp}
          />
        }
        
        {this.state.dbf &&
          <XDialog
            name='dbf'
            style={{
              right: (show_dialog_mav || show_zombie_mav ? 320 : 5),
              top: (show_mav_detail ? 250 : 50),
              width: this.state.dbf_width
            }}
            title={dbf_title}
            father={this}
            drag={false}
            cond={! this.props.hide_extras} {...font}
            children={
              <Dbf
                dbf={this.state.dbf}
                dbf_hl={this.state.dbf_hl}
                num_decimals={this.props.num_decimals}
                app={this.props.app}
              />
            }
          />
        }
        
        {(show_dialog_mav && this.state.escala_for != null && this.props.app.toolbar != null) &&
          <DialogMav
            culti={this.props.app.toolbar.state.culti}
            elem={this.state.escala_for}
            left={this.props.width - offset_map}
            num_decimals={this.props.num_decimals}
            app={this.props.app}
          />
        }
        
        {show_zombie_mav &&
          <PostMav {...this.state.zombie_mav} />
        }
        
        {(show_mav_detail && this.state.mav_detail != null) &&
          <XDialog
            name='mav_detail'
            title='Datos del Mav'
            father={this}
            drag={false}
            children={
              <TableMav
                mav_detail={this.state.mav_detail}
                num_decimals={this.props.num_decimals}
                father={this}
                ref={comp => this.table_mav = comp}
              />
            }
            style={{top: 50, right: (show_dialog_mav || show_zombie_mav ? 320 : 15)}}
            font={font.font}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MapUI.jsx